"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSplits = exports.getGroupingForQuery = exports.getGroupingByFilters = exports.INVENTORY_FILTERS = exports.EInventoryTableId = exports.EInventoryFilterId = exports.INVENTORY_EVENTS_TO_QUERY = void 0;
const primitive_1 = require("../../helpers/primitive.js");
const pull_1 = __importDefault(require("lodash/pull"));
const dbTableTraffic_1 = require("../reporterDb/dbTableTraffic");
const query_1 = require("../reporterDb/query");
const events_1 = require("./events");
const CREATIVE_SIZE_QUERY = (bannerFilterId, videoFilterId) => (value) => ({
    $or: [
        ...(0, query_1.STRICT_MULTI_LIKE_QUERY_CURRY)(bannerFilterId)(value.map((v) => v && v.replace(/_/g, ""))).$or,
        ...(0, query_1.STRICT_MULTI_LIKE_QUERY_CURRY)(videoFilterId)(value.map((v) => v && v.replace(/_/g, ""))).$or,
    ],
});
const NUMERIC_EXACT_QUERY_CURRY = (filterId) => (value) => (0, query_1.EXACT_QUERY_CURRY)(filterId)(value.map((v) => (0, primitive_1.toNumber)(v)));
exports.INVENTORY_EVENTS_TO_QUERY = [
    events_1.EInventoryEvents.requests,
    events_1.EInventoryEvents.requestsWithLogVolume,
];
var EInventoryFilterId;
(function (EInventoryFilterId) {
    EInventoryFilterId["GEO_COUNTRY"] = "GEO_COUNTRY";
    EInventoryFilterId["EXCHANGE"] = "EXCHANGE";
    EInventoryFilterId["DEVICE_OS"] = "DEVICE_OS";
    EInventoryFilterId["DEVICE_TYPE"] = "DEVICE_TYPE";
    EInventoryFilterId["CONNECTION"] = "CONNECTION";
    EInventoryFilterId["INVENTORY_CATEGORIES"] = "INVENTORY_CATEGORIES";
    EInventoryFilterId["INVENTORY_CREATIVE_TYPE"] = "INVENTORY_CREATIVE_TYPE";
    EInventoryFilterId["CREATIVE_FORMAT_SIZE"] = "CREATIVE_FORMAT_SIZE";
    EInventoryFilterId["TRACKING_ALLOWED"] = "TRACKING_ALLOWED_INT";
    EInventoryFilterId["DEVICE_VERSION"] = "DEVICE_VERSION";
    EInventoryFilterId["DEVICE_OS_VERSION"] = "DEVICE_OS_VERSION";
    EInventoryFilterId["HARDWARE_VERSION"] = "HARDWARE_VERSION";
    EInventoryFilterId["SKAD_VERSION"] = "SKAD_VERSION";
    EInventoryFilterId["CONTENT_RATING"] = "CONTENT_RATING";
})(EInventoryFilterId || (exports.EInventoryFilterId = EInventoryFilterId = {}));
var EInventoryTableId;
(function (EInventoryTableId) {
    EInventoryTableId["BANNER_FORMAT_SIZE"] = "BANNER_FORMAT_SIZE";
    EInventoryTableId["VIDEO_PLAYER_SIZE"] = "VIDEO_PLAYER_SIZE";
})(EInventoryTableId || (exports.EInventoryTableId = EInventoryTableId = {}));
exports.INVENTORY_FILTERS = {
    [EInventoryFilterId.GEO_COUNTRY]: {
        id: EInventoryFilterId.GEO_COUNTRY,
        name: "Country",
        type: "Dimension",
        dictionary: "country",
        query: (0, query_1.EXACT_QUERY_CURRY)(EInventoryFilterId.GEO_COUNTRY),
    },
    [EInventoryFilterId.EXCHANGE]: {
        id: EInventoryFilterId.EXCHANGE,
        name: "Exchange",
        type: "Dimension",
        dictionary: "exchange",
        query: (0, query_1.EXACT_QUERY_CURRY)(EInventoryFilterId.EXCHANGE),
    },
    [EInventoryFilterId.DEVICE_OS]: {
        id: EInventoryFilterId.DEVICE_OS,
        name: "Device OS",
        type: "Dimension",
        dictionary: "device-os-type",
        query: (0, query_1.EXACT_QUERY_CURRY)(EInventoryFilterId.DEVICE_OS),
    },
    [EInventoryFilterId.DEVICE_TYPE]: {
        id: EInventoryFilterId.DEVICE_TYPE,
        name: "Device Type",
        type: "Dimension",
        dictionary: "device-type",
        query: (0, query_1.EXACT_QUERY_CURRY)(EInventoryFilterId.DEVICE_TYPE),
    },
    [EInventoryFilterId.CONNECTION]: {
        id: EInventoryFilterId.CONNECTION,
        name: "Connection",
        type: "Dimension",
        dictionary: "device-connection-type",
        query: (0, query_1.EXACT_QUERY_CURRY)(EInventoryFilterId.CONNECTION),
    },
    [EInventoryFilterId.INVENTORY_CATEGORIES]: {
        id: EInventoryFilterId.INVENTORY_CATEGORIES,
        name: "Category",
        type: "Dimension",
        dictionary: "categories",
        query: (0, query_1.STRICT_MULTI_LIKE_QUERY_CURRY)(EInventoryFilterId.INVENTORY_CATEGORIES),
    },
    [EInventoryFilterId.INVENTORY_CREATIVE_TYPE]: {
        id: EInventoryFilterId.INVENTORY_CREATIVE_TYPE,
        name: "Creative Type",
        type: "Dimension",
        dictionary: "inventory-creative-type",
        query: (0, query_1.EXACT_QUERY_CURRY)(EInventoryFilterId.INVENTORY_CREATIVE_TYPE),
    },
    [EInventoryFilterId.CREATIVE_FORMAT_SIZE]: {
        id: EInventoryFilterId.CREATIVE_FORMAT_SIZE,
        combineDimensionIds: [
            EInventoryTableId.BANNER_FORMAT_SIZE,
            EInventoryTableId.VIDEO_PLAYER_SIZE,
        ],
        name: "Creative Size",
        type: "Dimension",
        dictionary: "creative-sizes",
        query: CREATIVE_SIZE_QUERY(EInventoryTableId.BANNER_FORMAT_SIZE, EInventoryTableId.VIDEO_PLAYER_SIZE),
        isEmptyValue: (v) => !v || v === "0x0",
        tooltip: {
            [EInventoryTableId.BANNER_FORMAT_SIZE]: "Banner Format Size",
            [EInventoryTableId.VIDEO_PLAYER_SIZE]: "Video Player Size",
        },
    },
    [EInventoryFilterId.TRACKING_ALLOWED]: {
        id: EInventoryFilterId.TRACKING_ALLOWED,
        name: "Has Device ID",
        type: "Dimension",
        staticDictionary: [
            { label: "Yes", value: "1" },
            { label: "No", value: "0" },
        ],
        query: NUMERIC_EXACT_QUERY_CURRY(EInventoryFilterId.TRACKING_ALLOWED),
    },
    [EInventoryFilterId.DEVICE_OS_VERSION]: {
        id: EInventoryFilterId.DEVICE_OS_VERSION,
        name: "Device OS Version",
        type: "Dimension",
        query: (0, query_1.EXACT_QUERY_CURRY)(EInventoryFilterId.DEVICE_OS_VERSION),
    },
    [EInventoryFilterId.DEVICE_VERSION]: {
        id: EInventoryFilterId.DEVICE_VERSION,
        name: "Device OS Minor",
        type: "Dimension",
        query: (0, query_1.EXACT_QUERY_CURRY)(EInventoryFilterId.DEVICE_VERSION),
    },
    [EInventoryFilterId.HARDWARE_VERSION]: {
        id: EInventoryFilterId.HARDWARE_VERSION,
        name: "Hardware Version",
        type: "Filter",
        query: (0, query_1.EXACT_QUERY_CURRY)(EInventoryFilterId.HARDWARE_VERSION),
    },
    [EInventoryFilterId.SKAD_VERSION]: {
        id: EInventoryFilterId.SKAD_VERSION,
        name: "SKAN Version",
        type: "Filter",
        query: (0, query_1.EXACT_QUERY_CURRY)(EInventoryFilterId.SKAD_VERSION),
    },
    [EInventoryFilterId.CONTENT_RATING]: {
        id: EInventoryFilterId.CONTENT_RATING,
        name: "Content Rating",
        type: "Filter",
        query: (0, query_1.EXACT_QUERY_CURRY)(EInventoryFilterId.CONTENT_RATING),
    },
};
const getGroupingByFilters = (filters) => {
    const groupBy = Object.keys(filters).filter((key) => { var _a, _b; return ((_b = (_a = filters[key]) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.length) > 0; });
    return groupBy;
};
exports.getGroupingByFilters = getGroupingByFilters;
const getGroupingForQuery = (filters, defaultSplits) => {
    let groupBy = Object.keys(filters).filter((key) => { var _a, _b; return ((_b = (_a = filters[key]) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.length) > 0; });
    groupBy.forEach((gr) => {
        if (filters[gr].combineDimensionIds) {
            (0, pull_1.default)(groupBy, gr);
            groupBy = groupBy.concat(filters[gr].combineDimensionIds);
        }
    });
    return [...new Set([...groupBy, ...defaultSplits])];
};
exports.getGroupingForQuery = getGroupingForQuery;
exports.defaultSplits = [
    dbTableTraffic_1.TrafficDimensionIds.APP_BUNDLE_COLUMN_ID,
    dbTableTraffic_1.TrafficDimensionIds.TAG_ID,
    EInventoryFilterId.DEVICE_OS,
    EInventoryFilterId.EXCHANGE,
    EInventoryFilterId.INVENTORY_CREATIVE_TYPE,
    EInventoryTableId.BANNER_FORMAT_SIZE,
    EInventoryTableId.VIDEO_PLAYER_SIZE,
    dbTableTraffic_1.TrafficDimensionIds.BUCKET_BID_FLOOR_COLUMN_ID,
    EInventoryFilterId.DEVICE_VERSION,
    EInventoryFilterId.DEVICE_OS_VERSION,
    EInventoryFilterId.HARDWARE_VERSION,
    EInventoryFilterId.SKAD_VERSION,
];
